import { AxiosResponse } from 'axios';

import { phpApi } from '../default';

export const downloadCertificate: (id: number) => Promise<AxiosResponse<void>> = (
  id: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/certificate/${id}`, { responseType: 'blob' });

export const downloadByFileType: (fileType: string, id: number) => Promise<AxiosResponse<void>> = (
  fileType: string, id: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/${fileType}/${id}`, { responseType: 'blob' });

export const downloadFile: (id: number) => Promise<AxiosResponse<void>> = (
  id: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/file/${id}`, { responseType: 'blob' });

export const downloadFileAsBlob: (id: number) => Promise<AxiosResponse<Buffer>> = (
  id: number
): Promise<AxiosResponse<Buffer>> => phpApi.get(`/download/file/${id}`, { responseType: 'blob', customEnv: { skipSaveAs: true } });
